import { computed as e, isRef as t, nextTick as n, onMounted as r, onUnmounted as i, reactive as a, readonly as o, ref as s, toValue as c, unref as l, watch as u } from "vue";
import { defaultDocument as d, tryOnMounted as f, tryOnScopeDispose as p, unrefElement as m, watchPausable as h } from "@vueuse/core";
import { dayjs as ee, formatters as g, object as te } from "@myparcel-frontend/utils";
//#region ../../node_modules/.pnpm/sortablejs@1.15.7/node_modules/sortablejs/modular/sortable.esm.js
function _(e, t, n) {
	return (t = se(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function v() {
	return v = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, v.apply(null, arguments);
}
function ne(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function re(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ne(Object(n), !0).forEach(function(t) {
			_(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ne(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function ie(e, t) {
	if (e == null) return {};
	var n, r, i = ae(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function ae(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
function oe(e, t) {
	if (typeof e != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (typeof r != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function se(e) {
	var t = oe(e, "string");
	return typeof t == "symbol" ? t : t + "";
}
function ce(e) {
	"@babel/helpers - typeof";
	return ce = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, ce(e);
}
var le = "1.15.7";
function y(e) {
	if (typeof window < "u" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(e);
}
var b = y(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), ue = y(/Edge/i), de = y(/firefox/i), fe = y(/safari/i) && !y(/chrome/i) && !y(/android/i), pe = y(/iP(ad|od|hone)/i), me = y(/chrome/i) && y(/android/i), he = {
	capture: !1,
	passive: !1
};
function x(e, t, n) {
	e.addEventListener(t, n, !b && he);
}
function S(e, t, n) {
	e.removeEventListener(t, n, !b && he);
}
function ge(e, t) {
	if (t) {
		if (t[0] === ">" && (t = t.substring(1)), e) try {
			if (e.matches) return e.matches(t);
			if (e.msMatchesSelector) return e.msMatchesSelector(t);
			if (e.webkitMatchesSelector) return e.webkitMatchesSelector(t);
		} catch {
			return !1;
		}
		return !1;
	}
}
function _e(e) {
	return e.host && e !== document && e.host.nodeType && e.host !== e ? e.host : e.parentNode;
}
function ve(e, t, n, r) {
	if (e) {
		n ||= document;
		do {
			if (t != null && (t[0] === ">" ? e.parentNode === n && ge(e, t) : ge(e, t)) || r && e === n) return e;
			if (e === n) break;
		} while (e = _e(e));
	}
	return null;
}
var ye = /\s+/g;
function be(e, t, n) {
	e && t && (e.classList ? e.classList[n ? "add" : "remove"](t) : e.className = ((" " + e.className + " ").replace(ye, " ").replace(" " + t + " ", " ") + (n ? " " + t : "")).replace(ye, " "));
}
function C(e, t, n) {
	var r = e && e.style;
	if (r) {
		if (n === void 0) return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
		!(t in r) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), r[t] = n + (typeof n == "string" ? "" : "px");
	}
}
function xe(e, t) {
	var n = "";
	if (typeof e == "string") n = e;
	else do {
		var r = C(e, "transform");
		r && r !== "none" && (n = r + " " + n);
	} while (!t && (e = e.parentNode));
	var i = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
	return i && new i(n);
}
function Se(e, t, n) {
	if (e) {
		var r = e.getElementsByTagName(t), i = 0, a = r.length;
		if (n) for (; i < a; i++) n(r[i], i);
		return r;
	}
	return [];
}
function Ce() {
	return document.scrollingElement || document.documentElement;
}
function w(e, t, n, r, i) {
	if (!(!e.getBoundingClientRect && e !== window)) {
		var a, o, s, c, l, u, d;
		if (e !== window && e.parentNode && e !== Ce() ? (a = e.getBoundingClientRect(), o = a.top, s = a.left, c = a.bottom, l = a.right, u = a.height, d = a.width) : (o = 0, s = 0, c = window.innerHeight, l = window.innerWidth, u = window.innerHeight, d = window.innerWidth), (t || n) && e !== window && (i ||= e.parentNode, !b)) do
			if (i && i.getBoundingClientRect && (C(i, "transform") !== "none" || n && C(i, "position") !== "static")) {
				var f = i.getBoundingClientRect();
				o -= f.top + parseInt(C(i, "border-top-width")), s -= f.left + parseInt(C(i, "border-left-width")), c = o + a.height, l = s + a.width;
				break;
			}
		while (i = i.parentNode);
		if (r && e !== window) {
			var p = xe(i || e), m = p && p.a, h = p && p.d;
			p && (o /= h, s /= m, d /= m, u /= h, c = o + u, l = s + d);
		}
		return {
			top: o,
			left: s,
			bottom: c,
			right: l,
			width: d,
			height: u
		};
	}
}
function we(e, t, n) {
	for (var r = Ae(e, !0), i = w(e)[t]; r;) {
		var a = w(r)[n], o = void 0;
		if (o = n === "top" || n === "left" ? i >= a : i <= a, !o) return r;
		if (r === Ce()) break;
		r = Ae(r, !1);
	}
	return !1;
}
function Te(e, t, n, r) {
	for (var i = 0, a = 0, o = e.children; a < o.length;) {
		if (o[a].style.display !== "none" && o[a] !== F.ghost && (r || o[a] !== F.dragged) && ve(o[a], n.draggable, e, !1)) {
			if (i === t) return o[a];
			i++;
		}
		a++;
	}
	return null;
}
function Ee(e, t) {
	for (var n = e.lastElementChild; n && (n === F.ghost || C(n, "display") === "none" || t && !ge(n, t));) n = n.previousElementSibling;
	return n || null;
}
function De(e, t) {
	var n = 0;
	if (!e || !e.parentNode) return -1;
	for (; e = e.previousElementSibling;) e.nodeName.toUpperCase() !== "TEMPLATE" && e !== F.clone && (!t || ge(e, t)) && n++;
	return n;
}
function Oe(e) {
	var t = 0, n = 0, r = Ce();
	if (e) do {
		var i = xe(e), a = i.a, o = i.d;
		t += e.scrollLeft * a, n += e.scrollTop * o;
	} while (e !== r && (e = e.parentNode));
	return [t, n];
}
function ke(e, t) {
	for (var n in e) if (e.hasOwnProperty(n)) {
		for (var r in t) if (t.hasOwnProperty(r) && t[r] === e[n][r]) return Number(n);
	}
	return -1;
}
function Ae(e, t) {
	if (!e || !e.getBoundingClientRect) return Ce();
	var n = e, r = !1;
	do
		if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
			var i = C(n);
			if (n.clientWidth < n.scrollWidth && (i.overflowX == "auto" || i.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (i.overflowY == "auto" || i.overflowY == "scroll")) {
				if (!n.getBoundingClientRect || n === document.body) return Ce();
				if (r || t) return n;
				r = !0;
			}
		}
	while (n = n.parentNode);
	return Ce();
}
function je(e, t) {
	if (e && t) for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
	return e;
}
function Me(e, t) {
	return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var Ne;
function Pe(e, t) {
	return function() {
		if (!Ne) {
			var n = arguments, r = this;
			n.length === 1 ? e.call(r, n[0]) : e.apply(r, n), Ne = setTimeout(function() {
				Ne = void 0;
			}, t);
		}
	};
}
function Fe() {
	clearTimeout(Ne), Ne = void 0;
}
function Ie(e, t, n) {
	e.scrollLeft += t, e.scrollTop += n;
}
function Le(e) {
	var t = window.Polymer, n = window.jQuery || window.Zepto;
	return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
function Re(e, t, n) {
	var r = {};
	return Array.from(e.children).forEach(function(i) {
		if (!(!ve(i, t.draggable, e, !1) || i.animated || i === n)) {
			var a = w(i);
			r.left = Math.min(r.left ?? Infinity, a.left), r.top = Math.min(r.top ?? Infinity, a.top), r.right = Math.max(r.right ?? -Infinity, a.right), r.bottom = Math.max(r.bottom ?? -Infinity, a.bottom);
		}
	}), r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
var T = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function ze() {
	var e = [], t;
	return {
		captureAnimationState: function() {
			e = [], this.options.animation && [].slice.call(this.el.children).forEach(function(t) {
				if (C(t, "display") !== "none" && t !== F.ghost) {
					e.push({
						target: t,
						rect: w(t)
					});
					var n = re({}, e[e.length - 1].rect);
					if (t.thisAnimationDuration) {
						var r = xe(t, !0);
						r && (n.top -= r.f, n.left -= r.e);
					}
					t.fromRect = n;
				}
			});
		},
		addAnimationState: function(t) {
			e.push(t);
		},
		removeAnimationState: function(t) {
			e.splice(ke(e, { target: t }), 1);
		},
		animateAll: function(n) {
			var r = this;
			if (!this.options.animation) {
				clearTimeout(t), typeof n == "function" && n();
				return;
			}
			var i = !1, a = 0;
			e.forEach(function(e) {
				var t = 0, n = e.target, o = n.fromRect, s = w(n), c = n.prevFromRect, l = n.prevToRect, u = e.rect, d = xe(n, !0);
				d && (s.top -= d.f, s.left -= d.e), n.toRect = s, n.thisAnimationDuration && Me(c, s) && !Me(o, s) && (u.top - s.top) / (u.left - s.left) === (o.top - s.top) / (o.left - s.left) && (t = Ve(u, c, l, r.options)), Me(s, o) || (n.prevFromRect = o, n.prevToRect = s, t ||= r.options.animation, r.animate(n, u, s, t)), t && (i = !0, a = Math.max(a, t), clearTimeout(n.animationResetTimer), n.animationResetTimer = setTimeout(function() {
					n.animationTime = 0, n.prevFromRect = null, n.fromRect = null, n.prevToRect = null, n.thisAnimationDuration = null;
				}, t), n.thisAnimationDuration = t);
			}), clearTimeout(t), i ? t = setTimeout(function() {
				typeof n == "function" && n();
			}, a) : typeof n == "function" && n(), e = [];
		},
		animate: function(e, t, n, r) {
			if (r) {
				C(e, "transition", ""), C(e, "transform", "");
				var i = xe(this.el), a = i && i.a, o = i && i.d, s = (t.left - n.left) / (a || 1), c = (t.top - n.top) / (o || 1);
				e.animatingX = !!s, e.animatingY = !!c, C(e, "transform", "translate3d(" + s + "px," + c + "px,0)"), this.forRepaintDummy = Be(e), C(e, "transition", "transform " + r + "ms" + (this.options.easing ? " " + this.options.easing : "")), C(e, "transform", "translate3d(0,0,0)"), typeof e.animated == "number" && clearTimeout(e.animated), e.animated = setTimeout(function() {
					C(e, "transition", ""), C(e, "transform", ""), e.animated = !1, e.animatingX = !1, e.animatingY = !1;
				}, r);
			}
		}
	};
}
function Be(e) {
	return e.offsetWidth;
}
function Ve(e, t, n, r) {
	return Math.sqrt((t.top - e.top) ** 2 + (t.left - e.left) ** 2) / Math.sqrt((t.top - n.top) ** 2 + (t.left - n.left) ** 2) * r.animation;
}
var He = [], Ue = { initializeByDefault: !0 }, We = {
	mount: function(e) {
		for (var t in Ue) Ue.hasOwnProperty(t) && !(t in e) && (e[t] = Ue[t]);
		He.forEach(function(t) {
			if (t.pluginName === e.pluginName) throw `Sortable: Cannot mount plugin ${e.pluginName} more than once`;
		}), He.push(e);
	},
	pluginEvent: function(e, t, n) {
		var r = this;
		this.eventCanceled = !1, n.cancel = function() {
			r.eventCanceled = !0;
		};
		var i = e + "Global";
		He.forEach(function(r) {
			t[r.pluginName] && (t[r.pluginName][i] && t[r.pluginName][i](re({ sortable: t }, n)), t.options[r.pluginName] && t[r.pluginName][e] && t[r.pluginName][e](re({ sortable: t }, n)));
		});
	},
	initializePlugins: function(e, t, n, r) {
		for (var i in He.forEach(function(r) {
			var i = r.pluginName;
			if (!(!e.options[i] && !r.initializeByDefault)) {
				var a = new r(e, t, e.options);
				a.sortable = e, a.options = e.options, e[i] = a, v(n, a.defaults);
			}
		}), e.options) if (e.options.hasOwnProperty(i)) {
			var a = this.modifyOption(e, i, e.options[i]);
			a !== void 0 && (e.options[i] = a);
		}
	},
	getEventProperties: function(e, t) {
		var n = {};
		return He.forEach(function(r) {
			typeof r.eventProperties == "function" && v(n, r.eventProperties.call(t[r.pluginName], e));
		}), n;
	},
	modifyOption: function(e, t, n) {
		var r;
		return He.forEach(function(i) {
			e[i.pluginName] && i.optionListeners && typeof i.optionListeners[t] == "function" && (r = i.optionListeners[t].call(e[i.pluginName], n));
		}), r;
	}
};
function Ge(e) {
	var t = e.sortable, n = e.rootEl, r = e.name, i = e.targetEl, a = e.cloneEl, o = e.toEl, s = e.fromEl, c = e.oldIndex, l = e.newIndex, u = e.oldDraggableIndex, d = e.newDraggableIndex, f = e.originalEvent, p = e.putSortable, m = e.extraEventProperties;
	if (t ||= n && n[T], t) {
		var h, ee = t.options, g = "on" + r.charAt(0).toUpperCase() + r.substr(1);
		window.CustomEvent && !b && !ue ? h = new CustomEvent(r, {
			bubbles: !0,
			cancelable: !0
		}) : (h = document.createEvent("Event"), h.initEvent(r, !0, !0)), h.to = o || n, h.from = s || n, h.item = i || n, h.clone = a, h.oldIndex = c, h.newIndex = l, h.oldDraggableIndex = u, h.newDraggableIndex = d, h.originalEvent = f, h.pullMode = p ? p.lastPutMode : void 0;
		var te = re(re({}, m), We.getEventProperties(r, t));
		for (var _ in te) h[_] = te[_];
		n && n.dispatchEvent(h), ee[g] && ee[g].call(t, h);
	}
}
var Ke = ["evt"], E = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.evt, i = ie(n, Ke);
	We.pluginEvent.bind(F)(e, t, re({
		dragEl: O,
		parentEl: k,
		ghostEl: A,
		rootEl: j,
		nextEl: qe,
		lastDownEl: Je,
		cloneEl: M,
		cloneHidden: Ye,
		dragStarted: ut,
		putSortable: N,
		activeSortable: F.active,
		originalEvent: r,
		oldIndex: Xe,
		oldDraggableIndex: Qe,
		newIndex: Ze,
		newDraggableIndex: $e,
		hideGhostForTarget: Ot,
		unhideGhostForTarget: kt,
		cloneNowHidden: function() {
			Ye = !0;
		},
		cloneNowShown: function() {
			Ye = !1;
		},
		dispatchSortableEvent: function(e) {
			D({
				sortable: t,
				name: e,
				originalEvent: r
			});
		}
	}, i));
};
function D(e) {
	Ge(re({
		putSortable: N,
		cloneEl: M,
		targetEl: O,
		rootEl: j,
		oldIndex: Xe,
		oldDraggableIndex: Qe,
		newIndex: Ze,
		newDraggableIndex: $e
	}, e));
}
var O, k, A, j, qe, Je, M, Ye, Xe, Ze, Qe, $e, et, N, tt = !1, nt = !1, rt = [], it, at, ot, st, ct, lt, ut, dt, ft, pt = !1, mt = !1, ht, P, gt = [], _t = !1, vt = [], yt = typeof document < "u", bt = pe, xt = ue || b ? "cssFloat" : "float", St = yt && !me && !pe && "draggable" in document.createElement("div"), Ct = function() {
	if (yt) {
		if (b) return !1;
		var e = document.createElement("x");
		return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
	}
}(), wt = function(e, t) {
	var n = C(e), r = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth), i = Te(e, 0, t), a = Te(e, 1, t), o = i && C(i), s = a && C(a), c = o && parseInt(o.marginLeft) + parseInt(o.marginRight) + w(i).width, l = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + w(a).width;
	if (n.display === "flex") return n.flexDirection === "column" || n.flexDirection === "column-reverse" ? "vertical" : "horizontal";
	if (n.display === "grid") return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
	if (i && o.float && o.float !== "none") {
		var u = o.float === "left" ? "left" : "right";
		return a && (s.clear === "both" || s.clear === u) ? "vertical" : "horizontal";
	}
	return i && (o.display === "block" || o.display === "flex" || o.display === "table" || o.display === "grid" || c >= r && n[xt] === "none" || a && n[xt] === "none" && c + l > r) ? "vertical" : "horizontal";
}, Tt = function(e, t, n) {
	var r = n ? e.left : e.top, i = n ? e.right : e.bottom, a = n ? e.width : e.height, o = n ? t.left : t.top, s = n ? t.right : t.bottom, c = n ? t.width : t.height;
	return r === o || i === s || r + a / 2 === o + c / 2;
}, Et = function(e, t) {
	var n;
	return rt.some(function(r) {
		var i = r[T].options.emptyInsertThreshold;
		if (!(!i || Ee(r))) {
			var a = w(r), o = e >= a.left - i && e <= a.right + i, s = t >= a.top - i && t <= a.bottom + i;
			if (o && s) return n = r;
		}
	}), n;
}, Dt = function(e) {
	function t(e, n) {
		return function(r, i, a, o) {
			var s = r.options.group.name && i.options.group.name && r.options.group.name === i.options.group.name;
			if (e == null && (n || s)) return !0;
			if (e == null || e === !1) return !1;
			if (n && e === "clone") return e;
			if (typeof e == "function") return t(e(r, i, a, o), n)(r, i, a, o);
			var c = (n ? r : i).options.group.name;
			return e === !0 || typeof e == "string" && e === c || e.join && e.indexOf(c) > -1;
		};
	}
	var n = {}, r = e.group;
	(!r || ce(r) != "object") && (r = { name: r }), n.name = r.name, n.checkPull = t(r.pull, !0), n.checkPut = t(r.put), n.revertClone = r.revertClone, e.group = n;
}, Ot = function() {
	!Ct && A && C(A, "display", "none");
}, kt = function() {
	!Ct && A && C(A, "display", "");
};
yt && !me && document.addEventListener("click", function(e) {
	if (nt) return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), nt = !1, !1;
}, !0);
var At = function(e) {
	if (O) {
		e = e.touches ? e.touches[0] : e;
		var t = Et(e.clientX, e.clientY);
		if (t) {
			var n = {};
			for (var r in e) e.hasOwnProperty(r) && (n[r] = e[r]);
			n.target = n.rootEl = t, n.preventDefault = void 0, n.stopPropagation = void 0, t[T]._onDragOver(n);
		}
	}
}, jt = function(e) {
	O && O.parentNode[T]._isOutsideThisEl(e.target);
};
function F(e, t) {
	if (!(e && e.nodeType && e.nodeType === 1)) throw `Sortable: \`el\` must be an HTMLElement, not ${{}.toString.call(e)}`;
	this.el = e, this.options = t = v({}, t), e[T] = this;
	var n = {
		group: null,
		sort: !0,
		disabled: !1,
		store: null,
		handle: null,
		draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
		swapThreshold: 1,
		invertSwap: !1,
		invertedSwapThreshold: null,
		removeCloneOnHide: !0,
		direction: function() {
			return wt(e, this.options);
		},
		ghostClass: "sortable-ghost",
		chosenClass: "sortable-chosen",
		dragClass: "sortable-drag",
		ignore: "a, img",
		filter: null,
		preventOnFilter: !0,
		animation: 0,
		easing: null,
		setData: function(e, t) {
			e.setData("Text", t.textContent);
		},
		dropBubble: !1,
		dragoverBubble: !1,
		dataIdAttr: "data-id",
		delay: 0,
		delayOnTouchOnly: !1,
		touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
		forceFallback: !1,
		fallbackClass: "sortable-fallback",
		fallbackOnBody: !1,
		fallbackTolerance: 0,
		fallbackOffset: {
			x: 0,
			y: 0
		},
		supportPointer: F.supportPointer !== !1 && "PointerEvent" in window && (!fe || pe),
		emptyInsertThreshold: 5
	};
	for (var r in We.initializePlugins(this, e, n), n) !(r in t) && (t[r] = n[r]);
	for (var i in Dt(t), this) i.charAt(0) === "_" && typeof this[i] == "function" && (this[i] = this[i].bind(this));
	this.nativeDraggable = !t.forceFallback && St, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? x(e, "pointerdown", this._onTapStart) : (x(e, "mousedown", this._onTapStart), x(e, "touchstart", this._onTapStart)), this.nativeDraggable && (x(e, "dragover", this), x(e, "dragenter", this)), rt.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), v(this, ze());
}
F.prototype = {
	constructor: F,
	_isOutsideThisEl: function(e) {
		!this.el.contains(e) && e !== this.el && (dt = null);
	},
	_getDirection: function(e, t) {
		return typeof this.options.direction == "function" ? this.options.direction.call(this, e, t, O) : this.options.direction;
	},
	_onTapStart: function(e) {
		if (e.cancelable) {
			var t = this, n = this.el, r = this.options, i = r.preventOnFilter, a = e.type, o = e.touches && e.touches[0] || e.pointerType && e.pointerType === "touch" && e, s = (o || e).target, c = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || s, l = r.filter;
			if (Vt(n), !O && !(/mousedown|pointerdown/.test(a) && e.button !== 0 || r.disabled) && !c.isContentEditable && !(!this.nativeDraggable && fe && s && s.tagName.toUpperCase() === "SELECT") && (s = ve(s, r.draggable, n, !1), !(s && s.animated) && Je !== s)) {
				if (Xe = De(s), Qe = De(s, r.draggable), typeof l == "function") {
					if (l.call(this, e, s, this)) {
						D({
							sortable: t,
							rootEl: c,
							name: "filter",
							targetEl: s,
							toEl: n,
							fromEl: n
						}), E("filter", t, { evt: e }), i && e.preventDefault();
						return;
					}
				} else if (l && (l = l.split(",").some(function(r) {
					if (r = ve(c, r.trim(), n, !1), r) return D({
						sortable: t,
						rootEl: r,
						name: "filter",
						targetEl: s,
						fromEl: n,
						toEl: n
					}), E("filter", t, { evt: e }), !0;
				}), l)) {
					i && e.preventDefault();
					return;
				}
				r.handle && !ve(c, r.handle, n, !1) || this._prepareDragStart(e, o, s);
			}
		}
	},
	_prepareDragStart: function(e, t, n) {
		var r = this, i = r.el, a = r.options, o = i.ownerDocument, s;
		if (n && !O && n.parentNode === i) {
			var c = w(n);
			if (j = i, O = n, k = O.parentNode, qe = O.nextSibling, Je = n, et = a.group, F.dragged = O, it = {
				target: O,
				clientX: (t || e).clientX,
				clientY: (t || e).clientY
			}, ct = it.clientX - c.left, lt = it.clientY - c.top, this._lastX = (t || e).clientX, this._lastY = (t || e).clientY, O.style["will-change"] = "all", s = function() {
				if (E("delayEnded", r, { evt: e }), F.eventCanceled) {
					r._onDrop();
					return;
				}
				r._disableDelayedDragEvents(), !de && r.nativeDraggable && (O.draggable = !0), r._triggerDragStart(e, t), D({
					sortable: r,
					name: "choose",
					originalEvent: e
				}), be(O, a.chosenClass, !0);
			}, a.ignore.split(",").forEach(function(e) {
				Se(O, e.trim(), Pt);
			}), x(o, "dragover", At), x(o, "mousemove", At), x(o, "touchmove", At), a.supportPointer ? (x(o, "pointerup", r._onDrop), !this.nativeDraggable && x(o, "pointercancel", r._onDrop)) : (x(o, "mouseup", r._onDrop), x(o, "touchend", r._onDrop), x(o, "touchcancel", r._onDrop)), de && this.nativeDraggable && (this.options.touchStartThreshold = 4, O.draggable = !0), E("delayStart", this, { evt: e }), a.delay && (!a.delayOnTouchOnly || t) && (!this.nativeDraggable || !(ue || b))) {
				if (F.eventCanceled) {
					this._onDrop();
					return;
				}
				a.supportPointer ? (x(o, "pointerup", r._disableDelayedDrag), x(o, "pointercancel", r._disableDelayedDrag)) : (x(o, "mouseup", r._disableDelayedDrag), x(o, "touchend", r._disableDelayedDrag), x(o, "touchcancel", r._disableDelayedDrag)), x(o, "mousemove", r._delayedDragTouchMoveHandler), x(o, "touchmove", r._delayedDragTouchMoveHandler), a.supportPointer && x(o, "pointermove", r._delayedDragTouchMoveHandler), r._dragStartTimer = setTimeout(s, a.delay);
			} else s();
		}
	},
	_delayedDragTouchMoveHandler: function(e) {
		var t = e.touches ? e.touches[0] : e;
		Math.max(Math.abs(t.clientX - this._lastX), Math.abs(t.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
	},
	_disableDelayedDrag: function() {
		O && Pt(O), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
	},
	_disableDelayedDragEvents: function() {
		var e = this.el.ownerDocument;
		S(e, "mouseup", this._disableDelayedDrag), S(e, "touchend", this._disableDelayedDrag), S(e, "touchcancel", this._disableDelayedDrag), S(e, "pointerup", this._disableDelayedDrag), S(e, "pointercancel", this._disableDelayedDrag), S(e, "mousemove", this._delayedDragTouchMoveHandler), S(e, "touchmove", this._delayedDragTouchMoveHandler), S(e, "pointermove", this._delayedDragTouchMoveHandler);
	},
	_triggerDragStart: function(e, t) {
		t ||= e.pointerType == "touch" && e, !this.nativeDraggable || t ? this.options.supportPointer ? x(document, "pointermove", this._onTouchMove) : t ? x(document, "touchmove", this._onTouchMove) : x(document, "mousemove", this._onTouchMove) : (x(O, "dragend", this), x(j, "dragstart", this._onDragStart));
		try {
			document.selection ? Ht(function() {
				document.selection.empty();
			}) : window.getSelection().removeAllRanges();
		} catch {}
	},
	_dragStarted: function(e, t) {
		if (tt = !1, j && O) {
			E("dragStarted", this, { evt: t }), this.nativeDraggable && x(document, "dragover", jt);
			var n = this.options;
			!e && be(O, n.dragClass, !1), be(O, n.ghostClass, !0), F.active = this, e && this._appendGhost(), D({
				sortable: this,
				name: "start",
				originalEvent: t
			});
		} else this._nulling();
	},
	_emulateDragOver: function() {
		if (at) {
			this._lastX = at.clientX, this._lastY = at.clientY, Ot();
			for (var e = document.elementFromPoint(at.clientX, at.clientY), t = e; e && e.shadowRoot && (e = e.shadowRoot.elementFromPoint(at.clientX, at.clientY), e !== t);) t = e;
			if (O.parentNode[T]._isOutsideThisEl(e), t) do {
				if (t[T]) {
					var n = void 0;
					if (n = t[T]._onDragOver({
						clientX: at.clientX,
						clientY: at.clientY,
						target: e,
						rootEl: t
					}), n && !this.options.dragoverBubble) break;
				}
				e = t;
			} while (t = _e(t));
			kt();
		}
	},
	_onTouchMove: function(e) {
		if (it) {
			var t = this.options, n = t.fallbackTolerance, r = t.fallbackOffset, i = e.touches ? e.touches[0] : e, a = A && xe(A, !0), o = A && a && a.a, s = A && a && a.d, c = bt && P && Oe(P), l = (i.clientX - it.clientX + r.x) / (o || 1) + (c ? c[0] - gt[0] : 0) / (o || 1), u = (i.clientY - it.clientY + r.y) / (s || 1) + (c ? c[1] - gt[1] : 0) / (s || 1);
			if (!F.active && !tt) {
				if (n && Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) < n) return;
				this._onDragStart(e, !0);
			}
			if (A) {
				a ? (a.e += l - (ot || 0), a.f += u - (st || 0)) : a = {
					a: 1,
					b: 0,
					c: 0,
					d: 1,
					e: l,
					f: u
				};
				var d = `matrix(${a.a},${a.b},${a.c},${a.d},${a.e},${a.f})`;
				C(A, "webkitTransform", d), C(A, "mozTransform", d), C(A, "msTransform", d), C(A, "transform", d), ot = l, st = u, at = i;
			}
			e.cancelable && e.preventDefault();
		}
	},
	_appendGhost: function() {
		if (!A) {
			var e = this.options.fallbackOnBody ? document.body : j, t = w(O, !0, bt, !0, e), n = this.options;
			if (bt) {
				for (P = e; C(P, "position") === "static" && C(P, "transform") === "none" && P !== document;) P = P.parentNode;
				P !== document.body && P !== document.documentElement ? (P === document && (P = Ce()), t.top += P.scrollTop, t.left += P.scrollLeft) : P = Ce(), gt = Oe(P);
			}
			A = O.cloneNode(!0), be(A, n.ghostClass, !1), be(A, n.fallbackClass, !0), be(A, n.dragClass, !0), C(A, "transition", ""), C(A, "transform", ""), C(A, "box-sizing", "border-box"), C(A, "margin", 0), C(A, "top", t.top), C(A, "left", t.left), C(A, "width", t.width), C(A, "height", t.height), C(A, "opacity", "0.8"), C(A, "position", bt ? "absolute" : "fixed"), C(A, "zIndex", "100000"), C(A, "pointerEvents", "none"), F.ghost = A, e.appendChild(A), C(A, "transform-origin", ct / parseInt(A.style.width) * 100 + "% " + lt / parseInt(A.style.height) * 100 + "%");
		}
	},
	_onDragStart: function(e, t) {
		var n = this, r = e.dataTransfer, i = n.options;
		if (E("dragStart", this, { evt: e }), F.eventCanceled) {
			this._onDrop();
			return;
		}
		E("setupClone", this), F.eventCanceled || (M = Le(O), M.removeAttribute("id"), M.draggable = !1, M.style["will-change"] = "", this._hideClone(), be(M, this.options.chosenClass, !1), F.clone = M), n.cloneId = Ht(function() {
			E("clone", n), !F.eventCanceled && (n.options.removeCloneOnHide || j.insertBefore(M, O), n._hideClone(), D({
				sortable: n,
				name: "clone"
			}));
		}), !t && be(O, i.dragClass, !0), t ? (nt = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (S(document, "mouseup", n._onDrop), S(document, "touchend", n._onDrop), S(document, "touchcancel", n._onDrop), r && (r.effectAllowed = "move", i.setData && i.setData.call(n, r, O)), x(document, "drop", n), C(O, "transform", "translateZ(0)")), tt = !0, n._dragStartId = Ht(n._dragStarted.bind(n, t, e)), x(document, "selectstart", n), ut = !0, window.getSelection().removeAllRanges(), fe && C(document.body, "user-select", "none");
	},
	_onDragOver: function(e) {
		var t = this.el, n = e.target, r, i, a, o = this.options, s = o.group, c = F.active, l = et === s, u = o.sort, d = N || c, f, p = this, m = !1;
		if (_t) return;
		function h(o, s) {
			E(o, p, re({
				evt: e,
				isOwner: l,
				axis: f ? "vertical" : "horizontal",
				revert: a,
				dragRect: r,
				targetRect: i,
				canSort: u,
				fromSortable: d,
				target: n,
				completed: g,
				onMove: function(n, i) {
					return Nt(j, t, O, r, n, w(n), e, i);
				},
				changed: te
			}, s));
		}
		function ee() {
			h("dragOverAnimationCapture"), p.captureAnimationState(), p !== d && d.captureAnimationState();
		}
		function g(r) {
			return h("dragOverCompleted", { insertion: r }), r && (l ? c._hideClone() : c._showClone(p), p !== d && (be(O, N ? N.options.ghostClass : c.options.ghostClass, !1), be(O, o.ghostClass, !0)), N !== p && p !== F.active ? N = p : p === F.active && N && (N = null), d === p && (p._ignoreWhileAnimating = n), p.animateAll(function() {
				h("dragOverAnimationComplete"), p._ignoreWhileAnimating = null;
			}), p !== d && (d.animateAll(), d._ignoreWhileAnimating = null)), (n === O && !O.animated || n === t && !n.animated) && (dt = null), !o.dragoverBubble && !e.rootEl && n !== document && (O.parentNode[T]._isOutsideThisEl(e.target), !r && At(e)), !o.dragoverBubble && e.stopPropagation && e.stopPropagation(), m = !0;
		}
		function te() {
			Ze = De(O), $e = De(O, o.draggable), D({
				sortable: p,
				name: "change",
				toEl: t,
				newIndex: Ze,
				newDraggableIndex: $e,
				originalEvent: e
			});
		}
		if (e.preventDefault !== void 0 && e.cancelable && e.preventDefault(), n = ve(n, o.draggable, t, !0), h("dragOver"), F.eventCanceled) return m;
		if (O.contains(e.target) || n.animated && n.animatingX && n.animatingY || p._ignoreWhileAnimating === n) return g(!1);
		if (nt = !1, c && !o.disabled && (l ? u || (a = k !== j) : N === this || (this.lastPutMode = et.checkPull(this, c, O, e)) && s.checkPut(this, c, O, e))) {
			if (f = this._getDirection(e, n) === "vertical", r = w(O), h("dragOverValid"), F.eventCanceled) return m;
			if (a) return k = j, ee(), this._hideClone(), h("revert"), F.eventCanceled || (qe ? j.insertBefore(O, qe) : j.appendChild(O)), g(!0);
			var _ = Ee(t, o.draggable);
			if (!_ || Lt(e, f, this) && !_.animated) {
				if (_ === O) return g(!1);
				if (_ && t === e.target && (n = _), n && (i = w(n)), Nt(j, t, O, r, n, i, e, !!n) !== !1) return ee(), _ && _.nextSibling ? t.insertBefore(O, _.nextSibling) : t.appendChild(O), k = t, te(), g(!0);
			} else if (_ && It(e, f, this)) {
				var v = Te(t, 0, o, !0);
				if (v === O) return g(!1);
				if (n = v, i = w(n), Nt(j, t, O, r, n, i, e, !1) !== !1) return ee(), t.insertBefore(O, v), k = t, te(), g(!0);
			} else if (n.parentNode === t) {
				i = w(n);
				var ne = 0, ie, ae = O.parentNode !== t, oe = !Tt(O.animated && O.toRect || r, n.animated && n.toRect || i, f), se = f ? "top" : "left", ce = we(n, "top", "top") || we(O, "top", "top"), le = ce ? ce.scrollTop : void 0;
				dt !== n && (ie = i[se], pt = !1, mt = !oe && o.invertSwap || ae), ne = Rt(e, n, i, f, oe ? 1 : o.swapThreshold, o.invertedSwapThreshold == null ? o.swapThreshold : o.invertedSwapThreshold, mt, dt === n);
				var y;
				if (ne !== 0) {
					var b = De(O);
					do
						b -= ne, y = k.children[b];
					while (y && (C(y, "display") === "none" || y === A));
				}
				if (ne === 0 || y === n) return g(!1);
				dt = n, ft = ne;
				var ue = n.nextElementSibling, de = !1;
				de = ne === 1;
				var fe = Nt(j, t, O, r, n, i, e, de);
				if (fe !== !1) return (fe === 1 || fe === -1) && (de = fe === 1), _t = !0, setTimeout(Ft, 30), ee(), de && !ue ? t.appendChild(O) : n.parentNode.insertBefore(O, de ? ue : n), ce && Ie(ce, 0, le - ce.scrollTop), k = O.parentNode, ie !== void 0 && !mt && (ht = Math.abs(ie - w(n)[se])), te(), g(!0);
			}
			if (t.contains(O)) return g(!1);
		}
		return !1;
	},
	_ignoreWhileAnimating: null,
	_offMoveEvents: function() {
		S(document, "mousemove", this._onTouchMove), S(document, "touchmove", this._onTouchMove), S(document, "pointermove", this._onTouchMove), S(document, "dragover", At), S(document, "mousemove", At), S(document, "touchmove", At);
	},
	_offUpEvents: function() {
		var e = this.el.ownerDocument;
		S(e, "mouseup", this._onDrop), S(e, "touchend", this._onDrop), S(e, "pointerup", this._onDrop), S(e, "pointercancel", this._onDrop), S(e, "touchcancel", this._onDrop), S(document, "selectstart", this);
	},
	_onDrop: function(e) {
		var t = this.el, n = this.options;
		if (Ze = De(O), $e = De(O, n.draggable), E("drop", this, { evt: e }), k = O && O.parentNode, Ze = De(O), $e = De(O, n.draggable), F.eventCanceled) {
			this._nulling();
			return;
		}
		tt = !1, mt = !1, pt = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Ut(this.cloneId), Ut(this._dragStartId), this.nativeDraggable && (S(document, "drop", this), S(t, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), fe && C(document.body, "user-select", ""), C(O, "transform", ""), e && (ut && (e.cancelable && e.preventDefault(), !n.dropBubble && e.stopPropagation()), A && A.parentNode && A.parentNode.removeChild(A), (j === k || N && N.lastPutMode !== "clone") && M && M.parentNode && M.parentNode.removeChild(M), O && (this.nativeDraggable && S(O, "dragend", this), Pt(O), O.style["will-change"] = "", ut && !tt && be(O, N ? N.options.ghostClass : this.options.ghostClass, !1), be(O, this.options.chosenClass, !1), D({
			sortable: this,
			name: "unchoose",
			toEl: k,
			newIndex: null,
			newDraggableIndex: null,
			originalEvent: e
		}), j === k ? Ze !== Xe && Ze >= 0 && (D({
			sortable: this,
			name: "update",
			toEl: k,
			originalEvent: e
		}), D({
			sortable: this,
			name: "sort",
			toEl: k,
			originalEvent: e
		})) : (Ze >= 0 && (D({
			rootEl: k,
			name: "add",
			toEl: k,
			fromEl: j,
			originalEvent: e
		}), D({
			sortable: this,
			name: "remove",
			toEl: k,
			originalEvent: e
		}), D({
			rootEl: k,
			name: "sort",
			toEl: k,
			fromEl: j,
			originalEvent: e
		}), D({
			sortable: this,
			name: "sort",
			toEl: k,
			originalEvent: e
		})), N && N.save()), F.active && ((Ze == null || Ze === -1) && (Ze = Xe, $e = Qe), D({
			sortable: this,
			name: "end",
			toEl: k,
			originalEvent: e
		}), this.save()))), this._nulling();
	},
	_nulling: function() {
		E("nulling", this), j = O = k = A = qe = M = Je = Ye = it = at = ut = Ze = $e = Xe = Qe = dt = ft = N = et = F.dragged = F.ghost = F.clone = F.active = null;
		var e = this.el;
		vt.forEach(function(t) {
			e.contains(t) && (t.checked = !0);
		}), vt.length = ot = st = 0;
	},
	handleEvent: function(e) {
		switch (e.type) {
			case "drop":
			case "dragend":
				this._onDrop(e);
				break;
			case "dragenter":
			case "dragover":
				O && (this._onDragOver(e), Mt(e));
				break;
			case "selectstart": e.preventDefault();
		}
	},
	toArray: function() {
		for (var e = [], t, n = this.el.children, r = 0, i = n.length, a = this.options; r < i; r++) t = n[r], ve(t, a.draggable, this.el, !1) && e.push(t.getAttribute(a.dataIdAttr) || Bt(t));
		return e;
	},
	sort: function(e, t) {
		var n = {}, r = this.el;
		this.toArray().forEach(function(e, t) {
			var i = r.children[t];
			ve(i, this.options.draggable, r, !1) && (n[e] = i);
		}, this), t && this.captureAnimationState(), e.forEach(function(e) {
			n[e] && (r.removeChild(n[e]), r.appendChild(n[e]));
		}), t && this.animateAll();
	},
	save: function() {
		var e = this.options.store;
		e && e.set && e.set(this);
	},
	closest: function(e, t) {
		return ve(e, t || this.options.draggable, this.el, !1);
	},
	option: function(e, t) {
		var n = this.options;
		if (t === void 0) return n[e];
		var r = We.modifyOption(this, e, t);
		n[e] = r === void 0 ? t : r, e === "group" && Dt(n);
	},
	destroy: function() {
		E("destroy", this);
		var e = this.el;
		e[T] = null, S(e, "mousedown", this._onTapStart), S(e, "touchstart", this._onTapStart), S(e, "pointerdown", this._onTapStart), this.nativeDraggable && (S(e, "dragover", this), S(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function(e) {
			e.removeAttribute("draggable");
		}), this._onDrop(), this._disableDelayedDragEvents(), rt.splice(rt.indexOf(this.el), 1), this.el = e = null;
	},
	_hideClone: function() {
		if (!Ye) {
			if (E("hideClone", this), F.eventCanceled) return;
			C(M, "display", "none"), this.options.removeCloneOnHide && M.parentNode && M.parentNode.removeChild(M), Ye = !0;
		}
	},
	_showClone: function(e) {
		if (e.lastPutMode !== "clone") {
			this._hideClone();
			return;
		}
		if (Ye) {
			if (E("showClone", this), F.eventCanceled) return;
			O.parentNode == j && !this.options.group.revertClone ? j.insertBefore(M, O) : qe ? j.insertBefore(M, qe) : j.appendChild(M), this.options.group.revertClone && this.animate(O, M), C(M, "display", ""), Ye = !1;
		}
	}
};
function Mt(e) {
	e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function Nt(e, t, n, r, i, a, o, s) {
	var c, l = e[T], u = l.options.onMove, d;
	return window.CustomEvent && !b && !ue ? c = new CustomEvent("move", {
		bubbles: !0,
		cancelable: !0
	}) : (c = document.createEvent("Event"), c.initEvent("move", !0, !0)), c.to = t, c.from = e, c.dragged = n, c.draggedRect = r, c.related = i || t, c.relatedRect = a || w(t), c.willInsertAfter = s, c.originalEvent = o, e.dispatchEvent(c), u && (d = u.call(l, c, o)), d;
}
function Pt(e) {
	e.draggable = !1;
}
function Ft() {
	_t = !1;
}
function It(e, t, n) {
	var r = w(Te(n.el, 0, n.options, !0)), i = Re(n.el, n.options, A), a = 10;
	return t ? e.clientX < i.left - a || e.clientY < r.top && e.clientX < r.right : e.clientY < i.top - a || e.clientY < r.bottom && e.clientX < r.left;
}
function Lt(e, t, n) {
	var r = w(Ee(n.el, n.options.draggable)), i = Re(n.el, n.options, A), a = 10;
	return t ? e.clientX > i.right + a || e.clientY > r.bottom && e.clientX > r.left : e.clientY > i.bottom + a || e.clientX > r.right && e.clientY > r.top;
}
function Rt(e, t, n, r, i, a, o, s) {
	var c = r ? e.clientY : e.clientX, l = r ? n.height : n.width, u = r ? n.top : n.left, d = r ? n.bottom : n.right, f = !1;
	if (!o) {
		if (s && ht < l * i) {
			if (!pt && (ft === 1 ? c > u + l * a / 2 : c < d - l * a / 2) && (pt = !0), pt) f = !0;
			else if (ft === 1 ? c < u + ht : c > d - ht) return -ft;
		} else if (c > u + l * (1 - i) / 2 && c < d - l * (1 - i) / 2) return zt(t);
	}
	return f ||= o, f && (c < u + l * a / 2 || c > d - l * a / 2) ? c > u + l / 2 ? 1 : -1 : 0;
}
function zt(e) {
	return De(O) < De(e) ? 1 : -1;
}
function Bt(e) {
	for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, r = 0; n--;) r += t.charCodeAt(n);
	return r.toString(36);
}
function Vt(e) {
	vt.length = 0;
	for (var t = e.getElementsByTagName("input"), n = t.length; n--;) {
		var r = t[n];
		r.checked && vt.push(r);
	}
}
function Ht(e) {
	return setTimeout(e, 0);
}
function Ut(e) {
	return clearTimeout(e);
}
yt && x(document, "touchmove", function(e) {
	(F.active || tt) && e.cancelable && e.preventDefault();
}), F.utils = {
	on: x,
	off: S,
	css: C,
	find: Se,
	is: function(e, t) {
		return !!ve(e, t, e, !1);
	},
	extend: je,
	throttle: Pe,
	closest: ve,
	toggleClass: be,
	clone: Le,
	index: De,
	nextTick: Ht,
	cancelNextTick: Ut,
	detectDirection: wt,
	getChild: Te,
	expando: T
}, F.get = function(e) {
	return e[T];
}, F.mount = function() {
	var e = [...arguments];
	e[0].constructor === Array && (e = e[0]), e.forEach(function(e) {
		if (!e.prototype || !e.prototype.constructor) throw `Sortable: Mounted plugin must be a constructor function, not ${{}.toString.call(e)}`;
		e.utils && (F.utils = re(re({}, F.utils), e.utils)), We.mount(e);
	});
}, F.create = function(e, t) {
	return new F(e, t);
}, F.version = le;
var I = [], Wt, Gt, Kt = !1, qt, Jt, Yt, Xt;
function Zt() {
	function e() {
		for (var e in this.defaults = {
			scroll: !0,
			forceAutoScrollFallback: !1,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			bubbleScroll: !0
		}, this) e.charAt(0) === "_" && typeof this[e] == "function" && (this[e] = this[e].bind(this));
	}
	return e.prototype = {
		dragStarted: function(e) {
			var t = e.originalEvent;
			this.sortable.nativeDraggable ? x(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? x(document, "pointermove", this._handleFallbackAutoScroll) : t.touches ? x(document, "touchmove", this._handleFallbackAutoScroll) : x(document, "mousemove", this._handleFallbackAutoScroll);
		},
		dragOverCompleted: function(e) {
			var t = e.originalEvent;
			!this.options.dragOverBubble && !t.rootEl && this._handleAutoScroll(t);
		},
		drop: function() {
			this.sortable.nativeDraggable ? S(document, "dragover", this._handleAutoScroll) : (S(document, "pointermove", this._handleFallbackAutoScroll), S(document, "touchmove", this._handleFallbackAutoScroll), S(document, "mousemove", this._handleFallbackAutoScroll)), $t(), Qt(), Fe();
		},
		nulling: function() {
			Yt = Gt = Wt = Kt = Xt = qt = Jt = null, I.length = 0;
		},
		_handleFallbackAutoScroll: function(e) {
			this._handleAutoScroll(e, !0);
		},
		_handleAutoScroll: function(e, t) {
			var n = this, r = (e.touches ? e.touches[0] : e).clientX, i = (e.touches ? e.touches[0] : e).clientY, a = document.elementFromPoint(r, i);
			if (Yt = e, t || this.options.forceAutoScrollFallback || ue || b || fe) {
				en(e, this.options, a, t);
				var o = Ae(a, !0);
				Kt && (!Xt || r !== qt || i !== Jt) && (Xt && $t(), Xt = setInterval(function() {
					var a = Ae(document.elementFromPoint(r, i), !0);
					a !== o && (o = a, Qt()), en(e, n.options, a, t);
				}, 10), qt = r, Jt = i);
			} else {
				if (!this.options.bubbleScroll || Ae(a, !0) === Ce()) {
					Qt();
					return;
				}
				en(e, this.options, Ae(a, !1), !1);
			}
		}
	}, v(e, {
		pluginName: "scroll",
		initializeByDefault: !0
	});
}
function Qt() {
	I.forEach(function(e) {
		clearInterval(e.pid);
	}), I = [];
}
function $t() {
	clearInterval(Xt);
}
var en = Pe(function(e, t, n, r) {
	if (t.scroll) {
		var i = (e.touches ? e.touches[0] : e).clientX, a = (e.touches ? e.touches[0] : e).clientY, o = t.scrollSensitivity, s = t.scrollSpeed, c = Ce(), l = !1, u;
		Gt !== n && (Gt = n, Qt(), Wt = t.scroll, u = t.scrollFn, Wt === !0 && (Wt = Ae(n, !0)));
		var d = 0, f = Wt;
		do {
			var p = f, m = w(p), h = m.top, ee = m.bottom, g = m.left, te = m.right, _ = m.width, v = m.height, ne = void 0, re = void 0, ie = p.scrollWidth, ae = p.scrollHeight, oe = C(p), se = p.scrollLeft, ce = p.scrollTop;
			p === c ? (ne = _ < ie && (oe.overflowX === "auto" || oe.overflowX === "scroll" || oe.overflowX === "visible"), re = v < ae && (oe.overflowY === "auto" || oe.overflowY === "scroll" || oe.overflowY === "visible")) : (ne = _ < ie && (oe.overflowX === "auto" || oe.overflowX === "scroll"), re = v < ae && (oe.overflowY === "auto" || oe.overflowY === "scroll"));
			var le = ne && (Math.abs(te - i) <= o && se + _ < ie) - (Math.abs(g - i) <= o && !!se), y = re && (Math.abs(ee - a) <= o && ce + v < ae) - (Math.abs(h - a) <= o && !!ce);
			if (!I[d]) for (var b = 0; b <= d; b++) I[b] || (I[b] = {});
			(I[d].vx != le || I[d].vy != y || I[d].el !== p) && (I[d].el = p, I[d].vx = le, I[d].vy = y, clearInterval(I[d].pid), (le != 0 || y != 0) && (l = !0, I[d].pid = setInterval(function() {
				r && this.layer === 0 && F.active._onTouchMove(Yt);
				var t = I[this.layer].vy ? I[this.layer].vy * s : 0, n = I[this.layer].vx ? I[this.layer].vx * s : 0;
				(typeof u != "function" || u.call(F.dragged.parentNode[T], n, t, e, Yt, I[this.layer].el) === "continue") && Ie(I[this.layer].el, n, t);
			}.bind({ layer: d }), 24))), d++;
		} while (t.bubbleScroll && f !== c && (f = Ae(f, !1)));
		Kt = l;
	}
}, 30), tn = function(e) {
	var t = e.originalEvent, n = e.putSortable, r = e.dragEl, i = e.activeSortable, a = e.dispatchSortableEvent, o = e.hideGhostForTarget, s = e.unhideGhostForTarget;
	if (t) {
		var c = n || i;
		o();
		var l = t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t, u = document.elementFromPoint(l.clientX, l.clientY);
		s(), c && !c.el.contains(u) && (a("spill"), this.onSpill({
			dragEl: r,
			putSortable: n
		}));
	}
};
function nn() {}
nn.prototype = {
	startIndex: null,
	dragStart: function(e) {
		var t = e.oldDraggableIndex;
		this.startIndex = t;
	},
	onSpill: function(e) {
		var t = e.dragEl, n = e.putSortable;
		this.sortable.captureAnimationState(), n && n.captureAnimationState();
		var r = Te(this.sortable.el, this.startIndex, this.options);
		r ? this.sortable.el.insertBefore(t, r) : this.sortable.el.appendChild(t), this.sortable.animateAll(), n && n.animateAll();
	},
	drop: tn
}, v(nn, { pluginName: "revertOnSpill" });
function rn() {}
rn.prototype = {
	onSpill: function(e) {
		var t = e.dragEl, n = e.putSortable || this.sortable;
		n.captureAnimationState(), t.parentNode && t.parentNode.removeChild(t), n.animateAll();
	},
	drop: tn
}, v(rn, { pluginName: "removeOnSpill" }), F.mount(new Zt()), F.mount(rn, nn);
//#endregion
//#region ../../node_modules/.pnpm/@vueuse+integrations@14.4.0_axios@1.18.1_debug@4.4.3_supports-color@8.1.1__supports-col_35ddc7da4df360e67ae1b67e3949eca0/node_modules/@vueuse/integrations/dist/useSortable.js
function an(e, t, n = {}) {
	let r, { document: i = d, watchElement: a = !1, ...o } = n, s = { onUpdate: (e) => {
		cn(t, e.oldIndex, e.newIndex, e);
	} }, c = () => {
		r?.destroy(), r = void 0;
	}, l = (e) => {
		!e || r !== void 0 || (r = new F(e, {
			...s,
			...o
		}));
	}, h = () => {
		let t = typeof e == "string" ? i?.querySelector(e) : m(e);
		t && l(t);
	}, ee = (e, t) => {
		if (t !== void 0) r?.option(e, t);
		else return r?.option(e);
	}, g;
	return a && typeof e != "string" ? g = u(() => m(e), (e) => {
		c(), e && l(e);
	}, {
		immediate: !0,
		flush: "post"
	}) : f(h), p(() => {
		g?.(), c();
	}), {
		stop: () => {
			c();
		},
		start: h,
		option: ee
	};
}
function on(e, t, n) {
	let r = e.children[n];
	e.insertBefore(t, r);
}
function sn(e) {
	e.parentNode && e.parentNode.removeChild(e);
}
function cn(e, r, i, a = null) {
	a != null && (sn(a.item), on(a.from, a.item, r));
	let o = t(e), s = o ? [...c(e)] : c(e);
	if (i >= 0 && i < s.length) {
		let t = s.splice(r, 1)[0];
		n(() => {
			s.splice(i, 0, t), o && (e.value = s);
		});
	}
}
//#endregion
//#region src/useDraggableSort/useDraggableSort.ts
var ln = (e, t, r = {}) => {
	let { onReorder: i, handleClass: a, ghostClass: o = "drag-ghost", animation: c = 150 } = r, l = s([...t.value]);
	return u(t, (e) => {
		l.value = [...e];
	}), an(e, l, {
		handle: a,
		ghostClass: o,
		animation: c,
		onUpdate: (e) => {
			let t = e.oldIndex, r = e.newIndex;
			t !== void 0 && r !== void 0 && (cn(l, t, r, e), n(() => {
				i?.([...l.value], t, r);
			}));
		}
	}), { list: l };
}, un = a({});
function dn() {
	let e = ([e, t]) => {
		let n = ee(), r = ee(e), i = ee(t);
		return t ? e ? n.isBetween(r, i) : n.isBefore(i) : n.isAfter(r);
	}, t = (t) => {
		let n = {}, r = te.flatten(t);
		return Object.entries(r).forEach(([t, r]) => {
			let i = t;
			if (!Array.isArray(r)) {
				n[i] = r;
				return;
			}
			let [a, o] = r;
			n[i] = e([a, o]);
		}), n;
	}, n = () => {
		let e = {}, t = [];
		for (let e = 0; e < localStorage.length; e++) {
			let n = localStorage.key(e);
			/* c8 ignore if - this is an edge case where localStorage.key(i) returns null */
			n && t.push(n);
		}
		return t.filter((e) => e.startsWith("features.")).forEach((t) => {
			let n = t.replace("features.", ""), r = localStorage.getItem(t) === "true";
			e[n] = r;
		}), e;
	};
	return {
		features: o(un),
		loadFeatures: (e) => {
			let r = t(e), i = n();
			Object.keys(un).forEach((e) => delete un[e]), Object.assign(un, {
				...r,
				...i
			});
		},
		isFeatureActive: (e) => un[e] ?? !1
	};
}
//#endregion
//#region src/useFilterQuery/index.ts
var fn = (e, t, n, r = "watch") => {
	r === "watch" && u(e, async () => {
		await i();
	}, { deep: !0 });
	let i = async () => {
		let r = n.currentRoute.value.query, i = l(e), a = {};
		Object.keys(i).forEach((e) => {
			let n = t.value.find((t) => t.name === e)?.type;
			if (n === "checkbox") {
				let t = i[e];
				a[e] = t.length ? t.join(";") : void 0;
				return;
			}
			if (n === "radio") {
				let t = i[e];
				a[e] = t ? String(t) : void 0;
				return;
			}
			if (n === "number") {
				let t = i[e];
				a[e] = t ? String(t) : void 0;
				return;
			}
			if (n === "dateRange") {
				let t = i[e], n = t?.from ? t.from.toISOString().split("T")[0] : "", r = t?.to ? t.to.toISOString().split("T")[0] : "";
				a[e] = n.length || r.length ? `${n};${r}` : void 0;
				return;
			}
		}), await n.replace({ query: {
			...r,
			...a
		} });
	}, a = () => {
		let r = n.currentRoute.value.query;
		if (t.value.filter((e) => r[e.name] !== void 0).length === 0) return;
		let i = {};
		t.value.forEach((e) => {
			let t = r[e.name], n = {
				checkbox: [],
				number: null,
				radio: null,
				dateRange: {
					from: null,
					to: null
				}
			};
			if (t === void 0) {
				i[e.name] = n[e.type];
				return;
			}
			if (e.type === "checkbox") {
				let n = t.split(";").filter((t) => e.options.find((e) => e.value === t));
				i[e.name] = n;
				return;
			}
			if (e.type === "number") {
				let n = Number(t);
				i[e.name] = Number.isNaN(n) ? null : n;
				return;
			}
			if (e.type === "radio") {
				let n = t, r = Number(n), a = e.options.find((e) => e.value === n || e.value === r);
				i[e.name] = a?.value ?? null;
			}
			if (e.type === "dateRange") {
				let n = t ? t.split(";") : [], r = new Date(n[0]), a = new Date(n[1]), o = (e) => !isNaN(e.getTime());
				i[e.name] = {
					from: o(r) ? r : null,
					to: o(a) ? a : null
				};
			}
		}), e.value = i;
	};
	return a(), {
		setFiltersToUrl: i,
		getFiltersFromUrl: a
	};
}, L = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, R = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
L.Dhl, L.Instabox, L.PostNl, R.PostNl, L.Bpost, R.Bpost, L.CheapCargo, R.CheapCargo, L.Dpd, R.Dpd, L.Instabox, R.Instabox, L.Dhl, R.Dhl, L.Bol, R.Bol, L.Ups, R.Ups, L.DhlForYou, R.DhlForYou, L.DhlParcelConnect, R.DhlParcelConnect, L.DhlEuroPlus, R.DhlEuroPlus, L.UpsStandard, R.UpsStandard, L.UpsExpressSaver, R.UpsExpressSaver, L.Gls, R.Gls, L.Brt, R.Brt, L.Trunkrs, R.Trunkrs, L.InPost, R.InPost, L.PosteItaliane, R.PosteItaliane, L.Spring, R.Spring, L.ViaTim, R.ViaTim, L.DhlFreight, R.DhlFreight, L.PostNl, R.POSTNL, L.Bpost, R.BPOST, L.CheapCargo, R.CHEAP_CARGO, L.Dpd, R.DPD, L.Instabox, R.INSTABOX, L.Dhl, R.DHL, L.Bol, R.BOL, L.Ups, R.UPS, L.DhlForYou, R.DHL_FOR_YOU, L.DhlParcelConnect, R.DHL_PARCEL_CONNECT, L.DhlEuroPlus, R.DHL_EUROPLUS, L.UpsStandard, R.UPS_STANDARD, L.UpsExpressSaver, R.UPS_EXPRESS_SAVER, L.Gls, R.GLS, L.Brt, R.BRT, L.Trunkrs, R.TRUNKRS, L.InPost, R.INPOST, L.PosteItaliane, R.POSTE_ITALIANE, L.Spring, R.SPRING, L.ViaTim, R.VIA_TIM, L.DhlFreight, R.DHL_FREIGHT, R.POSTNL, L.PostNl, R.BPOST, L.Bpost, R.CHEAP_CARGO, L.CheapCargo, R.DPD, L.Dpd, R.INSTABOX, L.Instabox, R.DHL, L.Dhl, R.BOL, L.Bol, R.UPS, L.Ups, R.DHL_FOR_YOU, L.DhlForYou, R.DHL_PARCEL_CONNECT, L.DhlParcelConnect, R.DHL_EUROPLUS, L.DhlEuroPlus, R.UPS_STANDARD, L.UpsStandard, R.UPS_EXPRESS_SAVER, L.UpsExpressSaver, R.GLS, L.Gls, R.BRT, L.Brt, R.TRUNKRS, L.Trunkrs, R.INPOST, L.InPost, R.POSTE_ITALIANE, L.PosteItaliane, R.SPRING, L.Spring, R.VIA_TIM, L.ViaTim, R.DHL_FREIGHT, L.DhlFreight, R.PostNl, L.PostNl, R.POSTNL, L.PostNl, R.Bpost, L.Bpost, R.BPOST, L.Bpost, R.CheapCargo, L.CheapCargo, R.CHEAP_CARGO, L.CheapCargo, R.Dpd, L.Dpd, R.DPD, L.Dpd, R.Instabox, L.Instabox, R.Dhl, L.Dhl, R.BolCom, L.Bol, R.Bol, L.Bol, R.BOL, L.Bol, R.Ups, L.Ups, R.DhlForYou, L.DhlForYou, R.DHL_FOR_YOU, L.DhlForYou, R.DhlParcelConnect, L.DhlParcelConnect, R.DHL_PARCEL_CONNECT, L.DhlParcelConnect, R.DhlEuroPlus, L.DhlEuroPlus, R.DHL_EUROPLUS, L.DhlEuroPlus, R.UpsStandard, L.UpsStandard, R.UPS_STANDARD, L.UpsStandard, R.UpsExpressSaver, L.UpsExpressSaver, R.UPS_EXPRESS_SAVER, L.UpsExpressSaver, R.Gls, L.Gls, R.GLS, L.Gls, R.Brt, L.Brt, R.BRT, L.Brt, R.Trunkrs, L.Trunkrs, R.TRUNKRS, L.Trunkrs, R.InPost, L.InPost, R.INPOST, L.InPost, R.PosteItaliane, L.PosteItaliane, R.POSTE_ITALIANE, L.PosteItaliane, R.Spring, L.Spring, R.SPRING, L.Spring, R.ViaTim, L.ViaTim, R.VIA_TIM, L.ViaTim, R.DhlFreight, L.DhlFreight, R.DHL_FREIGHT, L.DhlFreight, L.PostNl, L.Bpost, L.CheapCargo, L.Dpd, L.Instabox, L.Dhl, L.Bol, L.Ups, L.DhlForYou, L.DhlParcelConnect, L.DhlEuroPlus, L.UpsStandard, L.UpsExpressSaver, L.Gls, L.Brt, L.Trunkrs, L.InPost, L.PosteItaliane, L.Spring, L.ViaTim, L.DhlFreight;
var z = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
z.Austria, z.Belgium, z.Bulgaria, z.Croatia, z.Cyprus, z.CzechRepublic, z.Denmark, z.Estonia, z.Finland, z.France, z.Germany, z.Greece, z.Hungary, z.Ireland, z.Italy, z.Latvia, z.Lithuania, z.Luxembourg, z.Malta, z.Netherlands, z.Poland, z.Portugal, z.Romania, z.Slovakia, z.Slovenia, z.Spain, z.Sweden, Object.values(z), z.Angola, z.AntiguaAndBarbuda, z.Aruba, z.Bahamas, z.Belize, z.Benin, z.Bermuda, z.BonaireSintEustatiusAndSaba, z.Botswana, z.BurkinaFaso, z.Burundi, z.Cameroon, z.CanaryIslands, z.CentralAfricanRepublic, z.Comoros, z.CongoBrazzaville, z.CongoKinshasa, z.CoteDIvoire, z.Curacao, z.Djibouti, z.Dominica, z.DutchAntilles, z.EquatorialGuinea, z.Eritrea, z.Fiji, z.Gabon, z.Gambia, z.Ghana, z.Grenada, z.Guyana, z.HongKong, z.Kiribati, z.KoreaPeoplesDemocraticRepublic, z.Macao, z.Malawi, z.Mali, z.Mauritania, z.Nauru, z.Qatar, z.Rwanda, z.SaintKittsAndNevis, z.SaoTomeAndPrincipe, z.Seychelles, z.SierraLeone, z.SintMaarten, z.Suriname, z.SyrianArabRepublic, z.TimorLeste, z.Togo, z.Tonga, z.Tuvalu, z.Uganda, z.UnitedArabEmirates, z.Vanuatu, z.Yemen, z.Zimbabwe, z.Austria, z.Belgium, z.Bulgaria, z.Croatia, z.CzechRepublic, z.Estonia, z.Finland, z.France, z.Germany, z.Greece, z.Hungary, z.Ireland, z.Italy, z.Latvia, z.Lithuania, z.Luxembourg, z.Malta, z.Netherlands, z.Portugal, z.Romania, z.Slovakia, z.Slovenia, z.Spain, z.UnitedKingdom, z.Denmark, z.Germany, z.Sweden;
var B = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, V = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, H = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
B.EarlyMorning, V.EarlyMorning, B.Morning, V.Morning, B.Standard, V.Standard, B.Evening, V.Evening, B.Pickup, V.Pickup, B.PickupExpress, V.PickupExpress, B.SameDayDelivery, V.SameDayDelivery, B.Express, V.Express, V.EarlyMorning, B.EarlyMorning, V.Morning, B.Morning, V.Standard, B.Standard, V.Evening, B.Evening, V.Pickup, B.Pickup, V.PickupExpress, B.PickupExpress, V.SameDayDelivery, B.SameDayDelivery, V.Express, B.Express, B.EarlyMorning, H.EarlyMorning, B.Morning, H.Morning, B.Standard, H.Standard, B.Evening, H.Evening, B.Pickup, H.Pickup, B.PickupExpress, H.PickupExpress, B.SameDayDelivery, H.SameDayDelivery, B.Express, H.Express, H.EarlyMorning, V.EarlyMorning, H.Morning, V.Morning, H.Standard, V.Standard, H.Evening, V.Evening, H.Pickup, V.Pickup, H.PickupExpress, V.PickupExpress, H.SameDayDelivery, V.SameDayDelivery, H.Express, V.Express, B.EarlyMorning, B.Morning, B.Standard, B.Evening, B.Pickup, B.PickupExpress, B.SameDayDelivery, B.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var pn = {
	Registered: 0,
	HandedToCarrier: 3,
	Sorting: 4,
	Distribution: 5,
	Delivered: 7
}, U = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, W = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
W.Sunday, U.Sunday, W.Monday, U.Monday, W.Tuesday, U.Tuesday, W.Wednesday, U.Wednesday, W.Thursday, U.Thursday, W.Friday, U.Friday, W.Saturday, U.Saturday, U.Sunday, W.Sunday, U.Monday, W.Monday, U.Tuesday, W.Tuesday, U.Wednesday, W.Wednesday, U.Thursday, W.Thursday, U.Friday, W.Friday, U.Saturday, W.Saturday;
var mn = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
mn.Bytes, mn.Kilobytes, mn.Megabytes, mn.Gigabytes, mn.Terabytes;
var hn = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, gn = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
hn.Bol, gn.Bol, hn.Exact, gn.Exact, hn.Amazon, gn.Amazon, hn.Wix, gn.Wix, hn.ExactDe, gn.ExactDe, hn.Etsy, gn.Etsy, gn.Bol, hn.Bol, gn.Exact, hn.Exact, gn.Amazon, hn.Amazon, gn.Wix, hn.Wix, gn.ExactDe, hn.ExactDe, gn.Etsy, hn.Etsy;
var G = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, K = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
G.Unpaid, K.Unpaid, G.Due, K.Due, G.DuePrepayment, K.DuePrepayment, G.Reminder1, K.Reminder1, G.Reminder2, K.Reminder2, G.Dun, K.Dun, G.Collection, K.Collection, G.Instalments, K.Instalments, G.PaymentArrangement, K.PaymentArrangement, G.Dispute, K.Dispute, G.LegalProcedure, K.LegalProcedure, G.Insolvency, K.Insolvency, G.WriteOff, K.WriteOff, G.Pending, K.Pending, G.Cancelled, K.Cancelled, G.Paid, K.Paid, G.PaidOnline, K.PaidOnline, G.PaidAutomatic, K.PaidAutomatic, G.PaidCredit, K.PaidCredit, G.PaidZeroItems, K.PaidZeroItems, G.InvoiceWith0InvoiceItemsPaidZeroBalance, K.PaidZeroBalance, G.Due, G.Reminder1, G.Reminder2, G.Dun, G.Collection, G.Instalments, G.PaymentArrangement, G.Dispute, G.Paid, G.PaidOnline, G.PaidAutomatic, G.PaidCredit, G.PaidZeroItems;
var _n = {
	Info: "info",
	Success: "success",
	Warning: "warning",
	Error: "alert"
}, vn = { Toaster: "toaster" }, yn = {
	Asc: "ASC",
	Desc: "DESC"
}, bn = {
	Gram: "g",
	Kilogram: "kg"
};
bn.Gram, bn.Kilogram;
var xn = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
xn.Millimeter, xn.Centimeter, xn.Meter;
var Sn = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, Cn = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
Cn.PendingConcept, Cn.PendingRegistered, Cn.EnRouteHandedToCarrier, Cn.EnRouteSorting, Cn.EnRouteDistribution, Cn.EnRouteCustoms, Cn.DeliveredReadyForPickup, Cn.DeliveredAtRecipient, Cn.DeliveredPackagePickedUp;
var q = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, wn = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
wn.Light, q.Light, wn.Start, q.Start, wn.Plus, q.Plus, wn.Premium, q.Premium, wn.Max, q.Max, q.Light, wn.Light, q.Start, wn.Start, q.Plus, wn.Plus, q.Premium, wn.Premium, q.Max, wn.Max;
var Tn = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, En = {
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
Tn.Start, En.Start, Tn.Plus, En.Plus, Tn.Premium, En.Premium, Tn.Max, En.Max, En.Start, Tn.Start, En.Plus, Tn.Plus, En.Premium, Tn.Premium, En.Max, Tn.Max;
var Dn = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, On = {
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
Dn.Start, On.Start, Dn.Plus, On.Plus, Dn.Premium, On.Premium, Dn.Max, On.Max, On.Start, Dn.Start, On.Plus, Dn.Plus, On.Premium, Dn.Premium, On.Max, Dn.Max;
var kn = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, An = {
	Light: q.Light,
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
kn.Light, An.Light, kn.Start, An.Start, kn.Plus, An.Plus, kn.Premium, An.Premium, kn.Max, An.Max, An.Light, kn.Light, An.Start, kn.Start, An.Plus, kn.Plus, An.Premium, kn.Premium, An.Max, kn.Max;
var jn = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Mn = {
	Start: q.Start,
	Plus: q.Plus,
	Premium: q.Premium,
	Max: q.Max
};
jn.Start, Mn.Start, jn.Plus, Mn.Plus, jn.Premium, Mn.Premium, jn.Max, Mn.Max, Mn.Start, jn.Start, Mn.Plus, jn.Plus, Mn.Premium, jn.Premium, Mn.Max, jn.Max;
var J = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Nn = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Y = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
J.MyParcel, Nn.MyParcel, J.Flespakket, Nn.Flespakket, J.SendMyParcel, Nn.SendMyParcel, J.MyParcelIt, Nn.MyParcelIt, J.DeliverDutch, Nn.DeliverDutch, J.PostNlPlugin, Nn.PostNlPlugin, J.MyParcel, Y.MyParcelNl, J.Flespakket, Y.MyParcelNl, J.SendMyParcel, Y.MyParcelBe, J.MyParcelIt, Y.MyParcelIt, J.DeliverDutch, Y.DeliverDutch, J.PostNlPlugin, Y.PostNlPlugin, Y.MyParcelNl, J.MyParcel, Y.MyParcelBe, J.SendMyParcel, Y.MyParcelIt, J.MyParcelIt;
var Pn = {
	[Y.MyParcelNl]: {
		[Sn.HomeCountry]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[z.Netherlands]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[Sn.Eu]: [
			0,
			5e3,
			5e4
		],
		[Sn.Row]: [
			0,
			5e3,
			5e4
		],
		[z.Belgium]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		]
	},
	[Y.MyParcelBe]: {
		[Sn.HomeCountry]: [0, 5e4],
		[z.Belgium]: [0, 5e4],
		[z.Netherlands]: [
			0,
			1e4,
			25e3,
			5e4,
			1e5,
			15e4,
			2e5,
			25e4,
			3e5,
			35e4,
			4e5,
			45e4,
			5e5
		],
		[Sn.Eu]: [
			0,
			5e3,
			5e4
		],
		[Sn.Row]: [
			0,
			5e3,
			5e4
		]
	}
}, Fn = { [Y.MyParcelBe]: {
	[Sn.HomeCountry]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[z.Belgium]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[Sn.Eu]: [
		0,
		5e4,
		25e4,
		5e5
	],
	[Sn.Row]: [
		0,
		5e4,
		25e4,
		5e5
	]
} }, In = { [Y.MyParcelNl]: {
	[Sn.HomeCountry]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[z.Netherlands]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[Sn.Eu]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[Sn.Row]: [
		0,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	]
} }, Ln = { [Y.MyParcelNl]: {
	[Sn.HomeCountry]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[z.Netherlands]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[z.Belgium]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	],
	[z.Luxembourg]: [
		0,
		1e4,
		25e3,
		5e4,
		1e5,
		15e4,
		2e5,
		25e4,
		3e5,
		35e4,
		4e5,
		45e4,
		5e5
	]
} }, Rn = {
	[L.Bpost]: Fn,
	[L.PostNl]: Pn,
	[L.DhlForYou]: In,
	[L.DhlParcelConnect]: In,
	[L.DhlEuroPlus]: In,
	[L.Ups]: Ln,
	[L.UpsStandard]: Ln,
	[L.UpsExpressSaver]: Ln
}, X = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, zn = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
X.Package, zn.Package, X.Mailbox, zn.Mailbox, X.Letter, zn.Letter, X.DigitalStamp, zn.DigitalStamp, X.Pallet, zn.Pallet, X.PackageSmall, zn.PackageSmall, X.Envelope, zn.Envelope, zn.Package, X.Package, zn.Mailbox, X.Mailbox, zn.Letter, X.Letter, zn.DigitalStamp, X.DigitalStamp, zn.Pallet, X.Pallet, zn.PackageSmall, X.PackageSmall, zn.Envelope, X.Envelope;
var Z = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
X.Package, Z.PACKAGE, X.Mailbox, Z.MAILBOX, X.Letter, Z.UNFRANKED, X.DigitalStamp, Z.DIGITAL_STAMP, X.Pallet, Z.PALLET, X.PackageSmall, Z.SMALL_PACKAGE, X.Envelope, Z.ENVELOPE, Z.PACKAGE, X.Package, Z.MAILBOX, X.Mailbox, Z.UNFRANKED, X.Letter, Z.DIGITAL_STAMP, X.DigitalStamp, Z.PALLET, X.Pallet, Z.SMALL_PACKAGE, X.PackageSmall, Z.ENVELOPE, X.Envelope, X.Package, X.Mailbox, X.Letter, X.DigitalStamp, X.Pallet, X.PackageSmall, X.Envelope;
var Q = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
Q.PendingConcept, Q.PendingRegistered, Q.EnrouteHandedToCarrier, Q.EnrouteSorting, Q.EnrouteDistribution, Q.DeliveredAtCustoms, Q.DeliveredAtRecipient, Q.DeliveredPackagePickedUp, Q.DeliveredReturnShipmentPackagePickedUp, Q.DeliveredAtAgreedLocation, Q.PrintedLetter, Q.PrintedDigitalStamp, Q.InactiveConcept, Q.InactiveRegistered, Q.InactiveEnrouteHandedToCarrier, Q.InactiveEnrouteSorting, Q.InactiveEnrouteDistribution, Q.InactiveEnrouteCustoms, Q.InactiveDeliveredAtRecipient, Q.InactiveDeliveredReadyForPickup, Q.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/useInsurance/index.ts
function Bn() {
	return {
		createInsuranceOptions: (e, t) => e.reduce((e, n) => typeof t == "number" && n > t ? e : n === 0 ? (e.push({
			label: "none",
			value: n
		}), e) : (e.push({
			label: "shipping.insurance.insuredFor",
			translateParams: { amount: g.currency.format(n, {
				minimumFractionDigits: 0,
				maximumFractionDigits: 0
			}) },
			value: n
		}), e), []),
		getInsurance: ({ region: e = "", cc: t = "", carrierId: n, propositionKey: r }) => Rn?.[n]?.[r]?.[t] ?? Rn?.[n]?.[r]?.[e] ?? []
	};
}
//#endregion
//#region src/useNotification/index.ts
var Vn = s([]), Hn = s(0), Un = 6e3;
function Wn() {
	let e = ({ id: e, variant: n = _n.Info, canClose: r, withShadow: i, body: a, title: o, timeout: s = Un, location: c = vn.Toaster }) => {
		let l = e;
		l ||= (Hn.value++, Hn.value.toString()), Vn.value.unshift({
			id: l,
			body: a,
			variant: n,
			title: o,
			timeout: s,
			location: c,
			canClose: r,
			withShadow: i
		}), s && setTimeout(() => {
			t(l);
		}, s);
	}, t = (e) => {
		Vn.value = Vn.value.filter((t) => t.id !== e);
	};
	return {
		notifications: o(Vn),
		addNotification: e,
		removeNotification: t,
		clearNotifications: () => {
			Vn.value = [];
		}
	};
}
//#endregion
//#region src/usePointer/index.ts
function Gn() {
	let e = s(-1), t = (t) => {
		e.value = t;
	};
	return {
		pointer: o(e),
		updatePointer: t,
		resetPointer: () => {
			t(-1);
		},
		incrementPointer: (n) => {
			let r = n.length - 1;
			if (e.value >= r) return;
			let i = e.value + 1;
			t(i);
		},
		decrementPointer: () => {
			if (e.value < 0) return;
			let n = e.value - 1;
			t(n);
		}
	};
}
//#endregion
//#region src/useResetTree/ResetTreeControl.symbol.ts
var Kn = Symbol("ResetTreeControl"), qn = (e, t, r, a) => {
	let o = s([]), c = () => o.value.forEach((e) => e.pause()), l = () => o.value.forEach((e) => e.resume()), u = async (e) => {
		c();
		try {
			await e();
		} finally {
			await n(), l();
		}
	}, d = (n) => {
		let i = JSON.parse(JSON.stringify(e));
		r[n].forEach((e) => {
			let n = e.split("."), r = i, a = t;
			n.forEach((e, t) => {
				t === n.length - 1 ? r[e] = a[e] : (r = r[e], a = a[e]);
			});
		}), a ? a(i, !1) : Object.assign(e, i);
	}, f = () => {
		Object.keys(r).forEach((e) => {
			d(e);
		});
	}, p = () => {
		Object.keys(r).forEach((t) => {
			let r = h(() => te.get(e, t), async () => {
				c(), d(t), await n(), l();
			});
			o.value.push(r);
		});
	}, m = () => {
		o.value.forEach((e) => e.stop()), o.value = [];
	};
	return i(() => {
		m();
	}), {
		watchers: o,
		resetFields: d,
		runWithoutResets: u,
		pauseResets: c,
		resumeResets: l,
		initResetTreeWatchers: p,
		executeResetTree: f,
		stopResetTreeWatchers: m
	};
};
//#endregion
//#region src/useResize/index.ts
function Jn() {
	let e = s([]), t = (t) => {
		e.value.push(t);
	}, n = (t) => {
		e.value = e.value.filter((e) => e !== t);
	}, a = new ResizeObserver((t) => {
		!t[0] || !e.value.length || e.value.forEach((e) => e());
	});
	return r(() => {
		a.observe(document.body);
	}), i(() => {
		a.disconnect();
	}), {
		watchResize: t,
		unwatchResize: n
	};
}
//#endregion
//#region src/useSortControl/useSortControl.ts
var $ = a({});
function Yn(t, n = {}, r = { keepOnUnmount: !1 }) {
	/* c8 ignore if - This just guards against invalid sortProps */
	$[t] || ($[t] = {}), n && ($[t] = a(n));
	let s = {
		[yn.Asc]: "ascending",
		[yn.Desc]: "descending"
	}, c = e(() => u()), l = e(() => d()), u = () => Object.keys($[t]).find((e) => $[t][e]) ?? void 0, d = () => Object.values($[t]).find((e) => e) ?? void 0, f = (e) => e === u() ? d() : void 0, p = (e) => {
		let n = $[t][e];
		return n ? s[n] : "none";
	}, m = (e) => {
		for (let n in $[t]) n !== e && ($[t][n] = null);
	};
	return r.keepOnUnmount || i(() => {
		/* c8 ignore if - This just guards against invalid sortProps */
		$[t] && delete $[t];
	}), {
		allSorters: o($),
		sorters: o($[t]),
		sort: c,
		order: l,
		sortByColumn: (e) => {
			m(e), $[t][e] === yn.Desc ? $[t][e] = null : $[t][e] === yn.Asc ? $[t][e] = yn.Desc : $[t][e] = yn.Asc;
		},
		getOrder: f,
		getOrderBy: d,
		getOrderAriaLabel: p
	};
}
//#endregion
//#region src/useStates/states.ts
var Xn = [
	{
		name: "Alberta",
		code: "AB"
	},
	{
		name: "British Columbia",
		code: "BC"
	},
	{
		name: "Manitoba",
		code: "MB"
	},
	{
		name: "New Brunswick",
		code: "NB"
	},
	{
		name: "Newfoundland and Labrador",
		code: "NL"
	},
	{
		name: "Nova Scotia",
		code: "NS"
	},
	{
		name: "Northwest Territories",
		code: "NT"
	},
	{
		name: "Nunavut",
		code: "NU"
	},
	{
		name: "Ontario",
		code: "ON"
	},
	{
		name: "Prince Edward Island",
		code: "PE"
	},
	{
		name: "Saskatchewan",
		code: "SK"
	},
	{
		name: "Quebec",
		code: "QC"
	},
	{
		name: "Yukon",
		code: "YT"
	}
], Zn = [
	{
		name: "Alabama",
		code: "AL"
	},
	{
		name: "Alaska",
		code: "AK"
	},
	{
		name: "Arizona",
		code: "AZ"
	},
	{
		name: "Arkansas",
		code: "AR"
	},
	{
		name: "California",
		code: "CA"
	},
	{
		name: "Colorado",
		code: "CO"
	},
	{
		name: "Connecticut",
		code: "CT"
	},
	{
		name: "Delaware",
		code: "DE"
	},
	{
		name: "Florida",
		code: "FL"
	},
	{
		name: "Georgia",
		code: "GA"
	},
	{
		name: "Hawaii",
		code: "HI"
	},
	{
		name: "Idaho",
		code: "ID"
	},
	{
		name: "Illinois",
		code: "IL"
	},
	{
		name: "Indiana",
		code: "IN"
	},
	{
		name: "Iowa",
		code: "IA"
	},
	{
		name: "Kansas",
		code: "KS"
	},
	{
		name: "Kentucky",
		code: "KY"
	},
	{
		name: "Louisiana",
		code: "LA"
	},
	{
		name: "Maine",
		code: "ME"
	},
	{
		name: "Maryland",
		code: "MD"
	},
	{
		name: "Massachusetts",
		code: "MA"
	},
	{
		name: "Michigan",
		code: "MI"
	},
	{
		name: "Minnesota",
		code: "MN"
	},
	{
		name: "Mississippi",
		code: "MS"
	},
	{
		name: "Missouri",
		code: "MO"
	},
	{
		name: "Montana",
		code: "MT"
	},
	{
		name: "Nebraska",
		code: "NE"
	},
	{
		name: "Nevada",
		code: "NV"
	},
	{
		name: "New Hampshire",
		code: "NH"
	},
	{
		name: "New Jersey",
		code: "NJ"
	},
	{
		name: "New Mexico",
		code: "NM"
	},
	{
		name: "New York",
		code: "NY"
	},
	{
		name: "North Carolina",
		code: "NC"
	},
	{
		name: "North Dakota",
		code: "ND"
	},
	{
		name: "Ohio",
		code: "OH"
	},
	{
		name: "Oklahoma",
		code: "OK"
	},
	{
		name: "Oregon",
		code: "OR"
	},
	{
		name: "Pennsylvania",
		code: "PA"
	},
	{
		name: "Rhode Island",
		code: "RI"
	},
	{
		name: "South Carolina",
		code: "SC"
	},
	{
		name: "South Dakota",
		code: "SD"
	},
	{
		name: "Tennessee",
		code: "TN"
	},
	{
		name: "Texas",
		code: "TX"
	},
	{
		name: "Utah",
		code: "UT"
	},
	{
		name: "Vermont",
		code: "VT"
	},
	{
		name: "Virginia",
		code: "VA"
	},
	{
		name: "Washington",
		code: "WA"
	},
	{
		name: "Washington DC",
		code: "DC"
	},
	{
		name: "West Virginia",
		code: "WV"
	},
	{
		name: "Wisconsin",
		code: "WI"
	},
	{
		name: "Wyoming",
		code: "WY"
	}
], Qn = () => ({
	getStates: (e) => {
		switch (e) {
			case z.UnitedStatesOfAmerica: return Zn;
			case z.Canada: return Xn;
			default: return [];
		}
	},
	hasStates: (e) => {
		switch (e) {
			case z.UnitedStatesOfAmerica:
			case z.Canada: return !0;
			default: return !1;
		}
	}
}), $n = a(/* @__PURE__ */ new Set());
function er() {
	return {
		startRowLoading: (e) => {
			let t = Array.isArray(e) ? e : [e];
			for (let e of t) $n.add(e);
		},
		stopRowLoading: (e) => {
			let t = Array.isArray(e) ? e : [e];
			for (let e of t) $n.delete(e);
		},
		isRowLoading: (e) => $n.has(e)
	};
}
//#endregion
//#region src/useTableSelection/useTableSelection.ts
var tr = a({}), nr = a({});
function rr(t) {
	tr[t] || (tr[t] = {}), nr[t] || (nr[t] = []);
	let n = (e) => {
		if (!e) {
			Object.keys(tr[t]).forEach((e) => {
				tr[t][e] = !1;
			});
			return;
		}
		nr[t].forEach((n) => {
			tr[t][n] = e;
		});
	}, r = (e) => {
		tr[t][e] = !tr[t][e];
	}, i = (e) => {
		nr[t] = e;
	}, a = () => {
		let e = tr[t];
		Object.keys(e).forEach((t) => {
			delete e[t];
		});
	}, s = e(() => !nr[t] || !nr[t].length ? 0 : Object.values(tr[t]).filter((e) => e).length);
	return {
		allSelected: e(() => !nr[t] || Object.keys(nr[t]).length === 0 ? !1 : nr[t].every((e) => tr[t][e])),
		selection: o(tr[t]),
		selectedCount: s,
		select: r,
		setVisibleItems: i,
		toggleSelectAll: n,
		clearSelection: a
	};
}
//#endregion
//#region src/useToggle/index.ts
function ir() {
	let e = s(!1), t = (t) => {
		e.value = t;
	};
	return {
		toggle: o(e),
		updateToggle: t,
		toggleToggle: () => {
			t(!e.value);
		},
		toggleToTrue: () => {
			t(!0);
		},
		toggleToFalse: () => {
			t(!1);
		}
	};
}
//#endregion
//#region src/useTrackAndTrace/index.ts
function ar() {
	let e = (e, n) => {
		let r = e.status.current, i = t(e), a = n ? [
			{
				type: "header",
				description: n.registered,
				disabled: r < pn.Registered,
				status: pn.Registered
			},
			{
				type: "header",
				description: n.handedToCarrier,
				disabled: r < pn.HandedToCarrier,
				status: pn.HandedToCarrier
			},
			{
				type: "header",
				description: n.sorting,
				disabled: r < pn.Sorting,
				status: pn.Sorting
			},
			{
				type: "header",
				description: n.distribution,
				disabled: r < pn.Distribution,
				status: pn.Distribution
			},
			{
				type: "header",
				description: n.delivered,
				disabled: r < pn.Delivered,
				status: pn.Delivered
			}
		] : [], o;
		return o = a.length > 0 ? [...a, ...i].sort((e, t) => e.status - (t.type === "header" && t.status === pn.Delivered ? Infinity : t.status)) : [...i].sort((e, t) => e.date.localeCompare(t.date)), o;
	}, t = (e) => {
		let t = e.status.current, n = e.history.map((e) => ({
			type: "item",
			date: e.time,
			description: e.description,
			disabled: !1,
			status: e.status
		}));
		return n.push({
			type: "item",
			date: e.time,
			description: e.description,
			disabled: !1,
			status: t
		}), n;
	};
	return {
		getFormattedTrackAndTrace: e,
		getTrackAndTraceItems: t
	};
}
//#endregion
export { Kn as ResetTreeControlKey, ln as useDraggableSort, dn as useFeatures, fn as useFilterQuery, Bn as useInsurance, Wn as useNotification, Gn as usePointer, qn as useResetTree, Jn as useResize, Yn as useSortControl, Qn as useStates, er as useTableRowLoading, rr as useTableSelection, ir as useToggle, ar as useTrackAndTrace };
